// eslint-disable-next-line import/extensions
import 'vuetify/lib/styles/main.css';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { createVuetify } from 'vuetify';
import { ko, en, } from 'vuetify/locale';
// TODO 모바일 레거시 코드
// const mobileBreakpoint = parseInt(cssVariable.mobileScreenMaxWidth.replace('px', ''), 10);
const mobileBreakpoint = 360;
// 컴포넌트 외부에서 사용
// export const isMobile = window.innerWidth < mobileBreakpoint;
export const isMobile = false;
// eslint-disable-next-line object-curly-newline
const vuetify = createVuetify({
    components,
    directives,
    display: {
        mobileBreakpoint,
    },
    locale: {
        locale: 'ko',
        messages: {
            ko,
            en,
        },
    },
});
// TODO vuetify2 레거시 코드
// export default new Vuetify({
//   breakpoint: {
//     mobileBreakpoint,
//   },
//   lang: {
//     locales: {
//       ko,
//       en,
//     },
//     current: 'ko',
//   },
//   theme: {
//     dark: false,
//     default: 'light',
//     themes: {
//       light: {
//         primary,
//         anchor: primary.darken2,
//       },
//     },
//     options: {
//       customProperties: true,
//     },
//   },
// });
export default vuetify;
